module.exports = __webpack_public_path__ + "img/prove2.ec28568d.png";